import { useEffect } from 'react';

import lurkerMetrics from 'util/lurker-metrics';

const initScript = (pageType: string) => {
  const payload = {
    object_name: pageType,
  };
  lurkerMetrics('page_view', 'load', payload);
};

type Props = {
  pageType: string;
};

export const setDataLayer = (pageType: string) => {
  if (!(window as any).dataLayer) {
    (window as any).dataLayer = [];
  }
  const pageTypeIndex = (window as any).dataLayer.findIndex(
    (data: any, index: number) => data.site && index > 0,
  );
  const pageView = {
    site: {
      isMobile: false,
    },
    page: {
      pageType,
    },
  };
  if (pageTypeIndex === -1) {
    (window as any).dataLayer.push(pageView);
  } else {
    (window as any).dataLayer[pageTypeIndex] = pageView;
  }
};

const Lurker = (props: Props) => {
  const { pageType } = props;

  if (typeof window !== 'undefined') {
    useEffect(() => {
      setDataLayer(pageType);
      initScript(pageType);
    }, []);
  }

  return <></>;
};

export default Lurker;
